class LatePaymentModelConsts {
  public static readonly NameMinLength: number = 1;

  public static readonly NameMaxLength: number = 100;

  public static readonly DescriptionMaxLength: number = 500;
}

export default LatePaymentModelConsts;
